import React, { useState, useContext, useEffect } from "react";
import { StoreContext } from "../../../../../store";
import RequestQuoteCard from "./RequestQuoteCard";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "./quoteCard.css";
import axios from "axios";
import moment from "moment";
import Loading from "../../../../loading/Loading";
import NoData from "../../../../noData/NoData";

function Schedule({
  loading,
  setShowSchedule,
  searchResult,
  comLogo,
  compName,
  lines,
  onRequestQuote
}) {
  // const [loading, setLoading] = useState(false);
  // const [searchResult, setSearchResult] = useState([]);
  // const [comLogo, setComLogo] = useState([]);
  // const [compName, setCompName] = useState([]);
  // const [lines, setLines] = useState([]);
  const context = useContext(StoreContext);
  useEffect(() => {
    // console.log(
    //   context.originUnlocos.value.Code,
    //   context.destinationUnlocos.value.Code,
    //   context.directions,
    //   context.carrier,
    //   moment(context.cutOffDate.value).format("MM-DD-YYYY")
    // );
    // getScheduleCards();
  }, []);

  return (
    <div className="_orderScheduleSearchResultBody">
      <div className="_orderScheduleSearchResultBodyHeader">
        <h5 style={{ display: "flex", alignItems: "center", cursor: "text" }}>
          <span
            onClick={() => setShowSchedule(false)}
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIosIcon />
          </span>
          Order Plan
        </h5>
        {/* <div className="_orderScheduleSearchResultBodyHeaderButton">
          <h5>5 selected</h5>
          <div className="_solidButton">
            <button>Select</button>
          </div>
        </div> */}
      </div>
      <div className="_orderScheduleSearchCardParent">
        {searchResult.length === 0 ? (
          <NoData>
            <p>No schedule found!</p>
          </NoData>
        ) : (
          lines.map((element, index) => {
            return element.map((item, i) => {
              let date = new Date(0);
              date.setUTCSeconds(item.cutOff);
              const cutoffdate = moment(date).format("MM/DD/YYYY");
              const destinationdate = searchResult[index].destinationdate;
              const origindate = searchResult[index].origindate;
              const cut = item.cutOff;

              console.log(
                destinationdate,
                origindate,
                item,
                searchResult[index]
              );
              return (
                <div className="scheduleSearchcardbody" key={i}>
                  <RequestQuoteCard
                    i={i}
                    index={index}
                    item={item}
                    comLogo={comLogo}
                    compName={compName}
                    cutoffdate={cutoffdate}
                    onRequestQuote={onRequestQuote}
                    setShowSchedule={setShowSchedule}
                    destinationdate={destinationdate}
                    origindate={origindate}
                    cut={cut}
                  />
                </div>
              );
            });
          })
        )}
      </div>
    </div>
  );
}

export default Schedule;
